import { render, staticRenderFns } from "./TariffSetting.vue?vue&type=template&id=4fc91252&scoped=true"
import script from "./TariffSetting.vue?vue&type=script&lang=ts"
export * from "./TariffSetting.vue?vue&type=script&lang=ts"
import style0 from "./TariffSetting.vue?vue&type=style&index=0&id=4fc91252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc91252",
  null
  
)

export default component.exports